// グローバル fetch をラップし、/api/ 宛のリクエストすべてに
// セッションIDヘッダーを自動付与する。
// これにより各リクエスト関数を個別に書き換えることなく、
// バックエンドの認証ミドルウェアへ確実にセッションを渡せる。
//
// あわせて、保護APIが 401 を返した場合（セッション切れ・無効）には
// セッションを破棄してログイン画面へ誘導する。

const originalFetch = window.fetch.bind(window);

function resolveUrl(input: RequestInfo | URL): string {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.pathname;
  return input.url;
}

function isApiRequest(url: string): boolean {
  // 相対パス("/api/...") と絶対URL("https://host/api/...") の両方に対応
  return url.startsWith("/api/") || url.includes("/api/");
}

// ログイン・セッション確認は 401 リダイレクトの対象外にする
function isAuthBootstrapRequest(url: string): boolean {
  return (
    url.includes("/api/auth/login") ||
    url.includes("/api/auth/checkSession") ||
    url.includes("/api/auth/loadContextDeta")
  );
}

export function installApiClient() {
  window.fetch = async (
    input: RequestInfo | URL,
    init?: RequestInit,
  ): Promise<Response> => {
    const url = resolveUrl(input);

    if (!isApiRequest(url)) {
      return originalFetch(input, init);
    }

    const sessionId = localStorage.getItem("sessionId");
    const headers = new Headers(init?.headers || {});
    if (sessionId && !headers.has("x-session-id")) {
      headers.set("x-session-id", sessionId);
    }

    const response = await originalFetch(input, { ...init, headers });

    if (
      response.status === 401 &&
      !isAuthBootstrapRequest(url) &&
      localStorage.getItem("sessionId")
    ) {
      // セッションが失効した場合はクリアしてログインへ
      localStorage.removeItem("sessionId");
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }

    return response;
  };
}
